import { render, staticRenderFns } from "./assessmentScheme.vue?vue&type=template&id=169cc5d2&scoped=true"
import script from "./assessmentScheme.vue?vue&type=script&lang=js"
export * from "./assessmentScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cc5d2",
  null
  
)

export default component.exports